import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MOCK_ZONAS } from './mockOperaciones';

const AccesoZonas = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">Acceso mesas y barras</h1>
      <p className="text-gray-600 text-sm mb-6">
        Selecciona la zona para acceder de manera gráfica a sus mesas y, si existe, su barra.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {MOCK_ZONAS.map((z) => (
          <button
            key={z.id}
            type="button"
            onClick={() => navigate(`/restaurantes/operaciones/acceso/${z.id}`)}
            className="text-left bg-white rounded-lg shadow-sm border border-gray-200 p-5 hover:border-teal-300 hover:bg-teal-50/50 transition-colors"
          >
            <div className="flex items-start justify-between gap-4">
              <div>
                <div className="text-xs text-gray-500">Zona</div>
                <div className="text-xl font-semibold text-teal-800">{z.nombreZona}</div>
                <div className="mt-2 text-sm text-gray-600">
                  Mesas: <span className="font-medium">{z.mesas.length}</span>
                  {z.tieneBarra ? (
                    <>
                      {' '}
                      · Barra: <span className="font-medium text-teal-700">Sí</span>
                    </>
                  ) : (
                    <>
                      {' '}
                      · Barra: <span className="font-medium text-gray-600">No</span>
                    </>
                  )}
                </div>
              </div>
              <div className="text-gray-400 text-2xl">→</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AccesoZonas;

